import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { Dropdown } from '@tcc/crate';

const baseString = 'vra-product-year-selector';
const classString = classNames({
  [`${baseString}`]: true
});
const ProductYearSelector = ({
  onChange,
  productYears,
  selected
}) => {

  const options = productYears.reverse().map((productYear) => {
    return { id: productYear, value: productYear };
  });

  return (
    <section className={classString}>
      <Dropdown
        className={`${baseString}__select`}
        options={options}
        setValue={onChange}
        testId={`${baseString}__year-selector`}
        value={selected}
      />
    </section>
  );
};
ProductYearSelector.propTypes = {
  isVisible: propTypes.bool,
  onChange: propTypes.func,
  productYears: propTypes.array.isRequired,
  selected: propTypes.string
};
export default ProductYearSelector;
